// 安全的存储访问工具

// 检查是否在浏览器环境中运行
const isBrowser = () => typeof window !== 'undefined';

// 检查是否在Vercel环境中运行
const isVercelEnvironment = () => {
  return isBrowser() && window.location && window.location.hostname.includes('vercel.app');
};

// 安全的存储访问工具
export const safeStorage = {
  getItem(key) {
    try {
      if (isBrowser()) {
        const value = localStorage.getItem(key);
        if (isVercelEnvironment()) {
          console.log(`Vercel环境中获取${key}:`, value);
        }
        return value;
      }
      return null;
    } catch (error) {
      console.error(`获取${key}时出错:`, error);
      return null;
    }
  },
  setItem(key, value) {
    try {
      if (isBrowser()) {
        localStorage.setItem(key, value);
        if (isVercelEnvironment()) {
          console.log(`Vercel环境中设置${key}:`, value);
        }
      }
    } catch (error) {
      console.error(`设置${key}时出错:`, error);
    }
  },
  removeItem(key) {
    try {
      if (isBrowser()) {
        localStorage.removeItem(key);
        if (isVercelEnvironment()) {
          console.log(`Vercel环境中删除${key}`);
        }
      }
    } catch (error) {
      console.error(`删除${key}时出错:`, error);
    }
  }
};

// 导出工具函数
export { isBrowser, isVercelEnvironment };